import React, { useState } from 'react'

const SelectGames = ({onGamesSelect, gamesSelector}) => {
  const handleSelectActive = () => {
    onGamesSelect({...gamesSelector, selected: [], enabled: !gamesSelector.enabled})
  }

  return (
    <div>
      <div
        className={'select-games-button' + (!gamesSelector.enabled ? ' disabled' : '')} 
        onClick={handleSelectActive}
      >
      </div>
    </div>
  )
}

export default SelectGames
